import './GameTabs.css';
import { useNavigate } from "react-router-dom";
import React, { useContext } from 'react';
import { AppContext } from '../context/AppContext';
import { LuGift } from "react-icons/lu";
import { FaWhatsapp } from "react-icons/fa";

export default function GameTabs({ isAccountActive, whatsappNumber }) {
  const navigate = useNavigate();
  const { user } = useContext(AppContext);

  if (!isAccountActive) {
    return null;
  }

  const handleJackpotClick = () => {
    if (!user?.accountStatus) return;
    navigate("/king-jackpot");
  };

  const handleStarlineClick = () => {
    if (!user?.accountStatus) return;
    navigate("/king-starline");
  };

  const handleWhatsappClick = () => {
    if (!whatsappNumber) return;
    const cleanNumber = whatsappNumber.replace(/\s/g, "");
    window.open(`https://wa.me/${cleanNumber}`, "_blank");
  };

  const handleAddFundClick = () => {
    if (!user?.accountStatus) return;
    navigate("/funds/add");
  };

  return (
    <div className="game-tabs-container">

      {/* 🔥 TOP SECTION */}
      <div className="game-header1">
       <div className="gif-icon">
  <LuGift size={26} color="#080459" />
</div>
        <h2>Let's Start Playing Now!</h2>
        <p>Choose your favorite game</p>
      </div>

      {/* 🔥 BUTTONS */}
      <div className="game-tabs-wrapper">
        
        <button 
          className="game-tab bgchanges" 
          onClick={handleStarlineClick} 
          disabled={!user?.accountStatus}
        >
          {/* <LuGamepad2 size={18} color="#080459" /> */}
         Kalyan Starline
        </button>

        <button 
          className="game-tab bgchangeg2" 
          onClick={handleJackpotClick} 
          disabled={!user?.accountStatus}
        >
          {/* <HiOutlineClock size={18} color="#080459" /> */}
        Kalyan Jackpot
        </button>

      </div>

        <div className="game-tabs-wrapper1">
        
        <button 
          className="game-tab whatsapp-btn" 
          onClick={handleWhatsappClick} 
          disabled={!user?.accountStatus}
        >
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <FaWhatsapp size={20} color="#fff" />
            WhatsApp
          </div>
        </button>

        <button 
          className="game-tab bgchangeg2" 
          onClick={handleAddFundClick} 
          disabled={!user?.accountStatus}
        >
          {/* <HiOutlineClock size={18} color="#080459" /> */}
        Add Fund
        </button>

      </div>
    </div>
  );
}